import {
  dispatchSiteEvent,
  siteEventNames,
} from '../events/site-events';

import { getOptimizelyExperimentationString } from '../utils/optimizely-experimentation-utils';

window.epiHelpers = function epiHelpers() {};

/* options: {
    success: <function>,
    fail: <function>
  }
*/
epiHelpers.sendLeadToMailchimp = function(options) {
  // Get timestamp if required for Dealer interest
  var date = '';
  // Detect whether new/old INTEREST_DEALER by length;
  var dealerOptin = false;
  if (epiHelpers.getElementByMailchimpName('INTEREST_DEALER').length > 1) {
    // *NEW* Radio group, get selected value
    var selectedVal = epiHelpers.getCheckedRadioByMailchimpField('INTEREST_DEALER');
    if (selectedVal.indexOf('yes') != -1) {
      dealerOptin = true;
    }
    dealerOptin = epiHelpers.getCheckedRadioByMailchimpField('INTEREST_DEALER');
  } else {
    dealerOptin = epiHelpers.getCheckedByMailchimpField('INTEREST_DEALER');
  }
  var tags = [];
  if (epiHelpers.getValByMailchimpField('DRIP_TAGS') !== '') {
    tags = epiHelpers.getValByMailchimpField('DRIP_TAGS').split(',');
  }
  // Trim whitespace
  for (var i = 0; i <= tags.length; i++) {
    if (tags[i]) {
      tags[i].trim();
    }
  }
  // Add opt-in tag
  if (epiHelpers.getCheckedByMailchimpField('INTEREST_BRAND')) {
    tags.push('Opted In');
  }
  // Add date for dealer opt-in
  if (dealerOptin) {
    tags.push('Consumer Lead to Pickup');
  }
  var interests = '';
  // If product page
  if (window.productLineInterestName) {
    interests = window.productLineInterestName;
  }
  // If find a dealer
  var interestInputValues = epiHelpers.getMultipleValsByMailchimpField('PRODUCT_INTERESTS');
  if (interestInputValues != '') {
    interests = interestInputValues;
  }
  // Switch visualization campaigns
  var campaign = epiHelpers.getValByMailchimpField('CAMPAIGN');
  if (epiHelpers.getMultipleValsByMailchimpField('VIZ_KEY') !== '') {
    campaign = epiHelpers.getValByMailchimpField('CAMPAIGN_WITH_VISUALIZATION')
  }
  // Get Google Click Id (if exists for the form)
  let currentDate = new Date();
  // New Dealer Sampling page - Check if the form has an ide of #new-dealer-sampling-form. If so, the form will submit additional values from that form for drip
  let newDealerSampling = (document.querySelector('#new-dealer-sampling-form')) ? true : false;
  let { userID, utmCampaign, utmContent, utmMedium, utmSource, utmTerm } = window.dataLayer[0];
  let optimizelyExperiments = getOptimizelyExperimentationString();
  // Drip Call
  _dcq.push(
    [
      'identify',
      {
        email: epiHelpers.getValByMailchimpField('EMAIL'),
        first_name: epiHelpers.getValByMailchimpField('FNAME'),
        last_name: epiHelpers.getValByMailchimpField('LNAME'),
        phone: epiHelpers.getValByMailchimpField('PHONE'),
        address1: epiHelpers.getValByMailchimpField('ADDR_LINE1'),
        address2: epiHelpers.getValByMailchimpField('ADDR_LINE2'),
        city: epiHelpers.getValByMailchimpField('ADDR_CITY'),
        state: epiHelpers.getValByMailchimpField('ADDR_STATE'),
        zip: epiHelpers.getValByMailchimpField('ADDR_ZIP'),
        country: epiHelpers.getValByMailchimpField('ADDR_CNTRY'),
        source: epiHelpers.getValByMailchimpField('SOURCE'),
        gclid: epiHelpers.getValByMailchimpField('GCLID'),
        design_studio_id: epiHelpers.getValByMailchimpField('DESIGN_STUDIO_ID'),
        visualizer_source: epiHelpers.getValByMailchimpField('VISUALIZER_SOURCE'),
        d_opt_in: date,
        viz_key: epiHelpers.getMultipleValsByMailchimpField('VIZ_KEY'),
        campaign,
        product_interests: interests,
        page_submitted_from: window.location.href,
        tags: tags,
        last_form_submitted_date: currentDate,
        user_id: userID,
        ...(epiHelpers.checkStringLength(utmCampaign) && { utm_campaign: utmCampaign }),
        ...(epiHelpers.checkStringLength(utmContent) && { utm_content: utmContent }),
        ...(epiHelpers.checkStringLength(utmMedium) && { utm_medium: utmMedium }),
        ...(epiHelpers.checkStringLength(utmSource) && { utm_source: utmSource }),
        ...(epiHelpers.checkStringLength(utmTerm) && { utm_term: utmTerm }),
        ...(epiHelpers.checkStringLength(optimizelyExperiments) && { optimizely_experiments: optimizelyExperiments }),
        ...(newDealerSampling && { selected_bundle: epiHelpers.getValByMailchimpField('SELECTED_BUNDLE') }),
        ...(newDealerSampling && { store_number: epiHelpers.getValByMailchimpField('STORE_NUMBER')}),
        ...(newDealerSampling && { company_number: epiHelpers.getValByMailchimpField('COMPANY_NUMBER') }),
        ...(newDealerSampling && { company_name: epiHelpers.getValByMailchimpField('COMPANY_NAME') }),
        ...(newDealerSampling && { company_contact: epiHelpers.getValByMailchimpField('COMPANY_CONTACT') }),
        ...(newDealerSampling && { who_is_your_graber_tsm: epiHelpers.getValByMailchimpField('WHO_IS_YOUR_GRABER_TSM') }),
        success: function(data) {
          console.log(data);
          if (options !== undefined) {
            if (options.success !== undefined) {
              options.success(data);
            }
          }
        },
        failure: function(data) {
          console.log(data);
          if (options !== undefined) {
            if (options.fail !== undefined) {
              options.fail(data);
            }
          }
        },
      },
    ]
  );
  // GTM Call
  dispatchSiteEvent(siteEventNames.ON_FORM_SUBMIT_SUCCESS, {
    optin: epiHelpers.getCheckedByMailchimpField('INTEREST_BRAND'),
  });
};

epiHelpers.validateForm = function() {
  var isValid = true;
  var fieldErrorList = [];
  $('#epiFormWrapper form div.Form__Element.ValidationRequired').each(function() {
    // Remove error class
    $(this).removeClass('ValidationFail');
    // Determine select/input... or other
    var el, type;
    if ($(this).find('input').length !== 0) {
      // Determine input text or select, or radio
      el = $(this).find('input');
      type = el.attr('type');
    } else if ($(this).find('select') !== 0) {
      el = $(this).find('select');
      type = 'select';
    } else if ($(this).find('textarea') !== 0) {
      el = $(this).find('textarea');
      type = 'text';
    }
    if (el !== undefined) {
      const fieldWrapper = this;
      const fieldError = fieldWrapper.querySelector('.text-danger');
      if (!epiHelpers.simpleEpiValidationByType(el, type)) {
        isValid = false;
        $(this).addClass('ValidationFail');
        fieldErrorList.push(el);
        if (fieldError) {
          fieldError.classList.add('field-validation-error');
          fieldError.classList.remove('field-validation-valid');
        }
      } else {
        if (fieldError) {
          fieldError.classList.remove('field-validation-error');
          fieldError.classList.add('field-validation-valid');
        }
      }
    }
  });
  // Add focus to first error, if form is invalid
  // console.log(fieldErrorList.length);
  if (fieldErrorList.length > 0) {
    // form.classList.add('form-validation-failed');
    fieldErrorList[0].focus();
  }
  return isValid;
};

epiHelpers.validatePhoneIfExists = function() {
  var val = epiHelpers.getValByMailchimpField('PHONE');
  if (val === '') {
    // No value, note entered, no validation needed
    return true;
  } else {
    // Validate
    var isValid = new RegExp(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/).test(val),
      par = $('form [data-mailchimp="PHONE"]').parent();
    if (isValid) {
      par.removeClass('ValidationFail');
    } else {
      par.addClass('ValidationFail');
    }
    return isValid;
  }
};

epiHelpers.simpleEpiValidationByType = function(el, type) {
  var val = el.val();
  if (el.hasClass('u-validation__email')) {
    return new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(val);
  } else if (el.hasClass('u-validation__phone')) {
    return new RegExp(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/).test(val);
  } else if (el.hasClass('u-validation__zip')) {
    return new RegExp(/(^\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$)/).test(val);
  } else if (el.hasClass('u-validation__passwordMatch')) {
    // Validate for password strength
    if (!new RegExp(/^(?=.*[a-z])(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/).test(val)) {
      return false;
    }
    // Check for match
    var $prev;
    var match = true;
    $('form .u-validation__passwordMatch').each(function() {
      if ($prev) {
        if ($prev.val() !== $(this).val()) {
          match = false;
        }
      }
      $prev = $(this);
    });
    if (val.length === 0) {
      match =  false;
    }
    return match;
  } else {
    // Just check to see if empty
    if (type === 'text' || type === 'select' || type === 'hidden') {     
      if (val !== undefined && val !== null) {
        if (val.length === 0) {
          return false;
        }       
      }
      // For selects
      if (val === null) {
        return false;
      }
    }
    if (type === 'radio') {
      // Check to see if at least one radio is checked
      var checkedRadio = $(`[name="${el.attr('name')}"]:checked`);
      if (checkedRadio.length === 0) {
        return false;
      }
    }
  }
  return true;
};

epiHelpers.getMultipleValsByMailchimpField = function(name) {
  var el = epiHelpers.getElementByMailchimpName(name);
  var s = '';
  for (var i = 0; i < el.length; i++) {
    if (el.eq(i).is(':checked')) {
      s += el.eq(i).val() + ',';
    }
  }
  if (s.lastIndexOf(',') !== -1) {
    s = s.substr(0, s.lastIndexOf(','))
  }
  return s;
}

epiHelpers.getCheckedRadioByMailchimpField = function(name) {
  var el = epiHelpers.getElementByMailchimpName(name);
  for (var i = 0; i < el.length; i++) {
    if (el.eq(i).is(':checked')) {
      return el.eq(i).val();
    }
  }
  return '';
}

epiHelpers.getCheckedByMailchimpField = function(name) {
  var el = epiHelpers.getElementByMailchimpName(name);
  if (el.length === 1) {
    return el.is(':checked');
  } else {
    return false;
  }
};

epiHelpers.getValByMailchimpField = function(name) {
  var el = epiHelpers.getElementByMailchimpName(name);
  if (el.length === 1) {
    return el.val();
  } else if (el.length > 1) {
    var s = '';
    for (var i = 0; i < el.length; i++) {
      s += el.eq(i).val() + ',';
    }
    return s;
  } else {
    return '';
  }
};

epiHelpers.getElementByMailchimpName = function(name) {
  return $('form [data-mailchimp="' + name + '"]');
}

epiHelpers.scrollFormToFirstError = function() {
  $('html, body').animate({
    scrollTop: $('#epiFormWrapper').offset().top - 140
  }, 250);
};

epiHelpers.resetMailchimpForm = function() {
  epiHelpers.getElementByMailchimpName('FNAME').val('');
  epiHelpers.getElementByMailchimpName('LNAME').val('');
  epiHelpers.getElementByMailchimpName('EMAIL').val('');
  epiHelpers.getElementByMailchimpName('PHONE').val('');
  epiHelpers.getElementByMailchimpName('ADDR_LINE1').val('');
  epiHelpers.getElementByMailchimpName('ADDR_LINE2').val('');
  epiHelpers.getElementByMailchimpName('ADDR_CITY').val('');
  epiHelpers.getElementByMailchimpName('ADDR_STATE').val('');
  epiHelpers.getElementByMailchimpName('ADDR_ZIP').val('');
  epiHelpers.getElementByMailchimpName('ADDR_CNTRY').val('');
  epiHelpers.getElementByMailchimpName('INTEREST_BRAND').prop('checked', true);
  epiHelpers.getElementByMailchimpName('INTEREST_DEALER').prop('checked', true);
};

epiHelpers.disableSubmitButtonOnSend = function($btn) {
  var btn = ($btn instanceof jQuery) ? $btn[0] : $btn;
  btn.classList.add('o-form__submit--disabled');
  btn.setAttribute('data-prevvalue', btn.textContent);
  btn.setAttribute('disabled', 'disabled');
  btn.textContent = 'Submitting...';
};

epiHelpers.reenableSubmitButton = function($btn) {
  var btn = ($btn instanceof jQuery) ? $btn[0] : $btn;
  btn.classList.remove('o-form__submit--disabled');
  btn.removeAttribute('disabled');
  btn.textContent = btn.getAttribute('data-prevvalue');
};

epiHelpers.convertInputTypeToPassword = function() {
  $('#epiFormWrapper form .o-form__input--password').each(function() {
    $(this).attr('type', 'password');
  });
}

epiHelpers.checkStringLength = function(str) {
  return str.length > 0;
}
